import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaPinterestP } from "react-icons/fa";

import shape from "../assets/Footer/Shape.png";
// import fb from "../assets/Footer/fb.png";
// import twitter from "../assets/Footer/Twitter.png";
import instagram from "../assets/Footer/Instagram.png";
import fb from "../assets/Footer/facebook.png";
import x from "../assets/Footer/X.png";
// import insta from "../assets/Footer/Insta.png";
import paypal from "../assets/Footer/paypal.png";
import mastercard from "../assets/Footer/mastercard.png";
import visa from "../assets/Footer/visa.png";
import googleplay from "../assets/Footer/googleplay.png";
import appstore from "../assets/Footer/appstore.png";

function Footer() {
    const navigate = useNavigate();

    const items = (id, Name) => {
        navigate("/items", { state: { categoryId: id, Name, category: "HOME" } });
    };

    const goTo = (path) => {
        navigate(path);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`);
                if (!response.ok) {
                    throw new Error("Failed to fetch categories");
                }
                const data = await response.json();
                // Filter only single-word names (no spaces)
                const singleWordCategories = data.filter((category) => category.Name && !category.Name.includes(" "));
                setCategories(singleWordCategories.slice(0, 6)); // limit to first 10
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, [apiBaseUrl]);

    return (
        // <div className="w-full h-auto flex flex-col bg-[white] ">
        //     <div className="w-full h-[32.859174964438125vh] sm:relative hidden sm:block">
        //         <img src={shape} alt="shape" style={{ width: "100%", height: "100%" }} />
        //     </div>
        //     <div className="w-full h-[150px] sm:h-[176px]  flex justify-center items-center sm:absolute sm:mt-[7%]">
        //         <div className="w-[100%] sm:w-[60%] md:h-[100%] h-[60%] bg-[#08090B] rounded-none sm:rounded-[9px]">
        //             <div className="md:h-[100%] h-[60%] p-5 flex items-center justify-around">
        //                 {/* Left section */}
        //                 <div className=" flex flex-col justify-center text-[white] space-y-2">
        //                     <h1 className="font-bold text-lg">Subscribe Newsletters</h1>
        //                     <p className="font-light text-sm">
        //                         Stay in style with our monthly newsletter! <br />
        //                         Get exclusive updates on new arrivals, sales, and fashion tips <br />
        //                         straight to your inbox.
        //                     </p>
        //                 </div>

        //                 {/* Right section */}
        //                 <div className="flex h-full items-center">
        //                     <input
        //                         type="email"
        //                         name="email"
        //                         placeholder="Enter your email"
        //                         className="border border-[white] rounded-l-md px-2 py-1"
        //                     />
        //                     <button
        //                         type="submit"
        //                         className="text-[white] border border-[white] rounded-r-md px-2 py-1"
        //                     >
        //                         Subscribe Now
        //                     </button>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        //     <div className="w-full h-[50px] sm:h-[150px]  flex flex-row justify-center items-center "></div>
        //     <div className="w-full h-[60px] sm:h-[90px] flex flex-col sm:flex-row  justify-center items-center ">
        //         <div className="h-[100%] w-[20%] hidden sm:block"></div>
        //         <div className="h-[100%] w-[100%] sm:w-[60%] flex flex-row  px-3 sm:px-[0] justify-center  gap-[10%]">
        //             <span
        //                 onClick={() => goTo("/home")}
        //                 className="text-xs sm:text-base text-[700] font-display underline cursor-pointer"
        //             >
        //                 Home
        //             </span>
        //             <span
        //                 onClick={() => goTo("/about")}
        //                 className="text-xs sm:text-base text-[700] font-display underline cursor-pointer"
        //             >
        //                 About Us
        //             </span>
        //             <span
        //                 onClick={() => goTo("/contact")}
        //                 className="text-xs sm:text-base text-[700] font-display underline cursor-pointer"
        //             >
        //                 Contact Us
        //             </span>
        //         </div>
        //         <div className="h-[100%] w-[100%] sm:w-[20%]  gap-[8%]  box-border flex flex-row justify-center sm:justify-end px-3 pr-8">
        //             <div>
        //                 <a href="#">
        //                     <img src={fb} alt="fb" />
        //                 </a>
        //             </div>
        //             <div>
        //                 <a href="#">
        //                     <img src={x} alt="twitter" />
        //                 </a>
        //             </div>
        //             <div>
        //                 <a href="#">
        //                     <img src={instagram} alt="instagram" />
        //                 </a>
        //             </div>
        //         </div>
        //     </div>
        //     <hr />
        //     <div className="h-[60px] w-full flex flex-row justify-center items-center">
        //         <div className="h-[100%] w-[50%] sm:w-[20%]  flex flex-row justify-start items-center px-[0] sm:px-3 text-xs font-display text-[400]">
        //             © 2023 All rights reserved
        //         </div>
        //         <div className="h-[100%] w-[60%] hidden sm:block"></div>
        //         <div className="h-[100%] w-[50%] sm:w-[20%] flex flex-row justify-end items-center px-[0]  sm:px-3 text-xs font-display text-[400] gap-[10%]">
        //             <span onClick={() => goTo("/termsandconditions")} className=" cursor-pointer">
        //                 Terms & Conditions
        //             </span>
        //             <span onClick={() => goTo("/privacypolicy")} className=" cursor-pointer">
        //                 Privacy Policy
        //             </span>
        //         </div>
        //     </div>
        // </div>

        <div className="w-full bg-white text-sm ">
            {/* Main Footer */}
            <div className="w-full px-8 md:px-40 py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 justify-around">
                {/* Top Categories */}
                <div className="mb-6">
                    <h3 className="font-semibold mb-2">Top Categories</h3>
                    {categories.map((category) => (
                        <div>
                            <div
                                onClick={() => items(category.Id, category.Name, "Footer")}
                                key={category.ItemName}
                                className="space-y-2 text-[#4B5563]"
                            >
                                <div key={category.ItemName} className="mb-2">
                                    <span className="text-[#4B5563] cursor-pointer">{category.Name}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* <ul className="space-y-2 text-[#4B5563]">
                        <li>Laptops</li>
                        <li>PC & Computers</li>
                        <li>Cell Phones</li>
                        <li>Tablets</li>
                        <li>Gaming & VR</li>
                        <li>Networks</li>
                        <li>Cameras</li>
                        <li>Sounds</li>
                        <li>Office</li>
                    </ul> */}
                </div>

                {/* Company */}
                <div className="mb-6 hidden md:block">
                    <h3 className="font-semibold text-black mb-2">Company</h3>
                    <ul className="space-y-2 text-[#4B5563] cursor-pointer">
                        <li>
                            <span onClick={() => goTo("/about")}>About Alik Store</span>
                        </li>
                        <li>
                            <span onClick={() => goTo("/contact")}>Contact</span>
                        </li>
                        {/* <li className="text-[red]">Career</li>
                        <li className="text-[red]">Blog</li>
                        <li className="text-[red]">Sitemap</li>
                        <li className="text-[red]">Store Locations</li> */}
                    </ul>
                </div>

                {/* Help Center */}
                <div className="mb-6">
                    <h3 className="font-semibold text-black mb-2">Help Center</h3>
                    <ul className="space-y-2 text-[#4B5563]">
                        {/* <li className="text-[red]">Customer Service</li> */}
                        <li>
                            <span onClick={() => goTo("/privacypolicy")} className=" cursor-pointer">
                                Policy
                            </span>
                        </li>
                        <li>
                            <span onClick={() => goTo("/termsandconditions")} className=" cursor-pointer">
                                Terms & Conditions
                            </span>
                        </li>
                        {/* <li>Track Order</li> */}
                        {/* <li className="text-[red]">FAQs</li> */}
                        {/* <li>My Account</li> */}
                        {/* <li className="text-[red]">Product Support</li> */}
                    </ul>
                </div>

                {/* Subscribe */}
                <div className="col-span-2 mb-6">
                    <h3 className="font-semibold text-black mb-2">
                        Subscribe & Get <span className="text-[#EF4444]">10%</span> OFF
                    </h3>
                    <div className="flex mt-2">
                        <input
                            type="email"
                            placeholder="Email Address"
                            className=" px-3 py-2 rounded-l-md w-60 bg-[#dfe2e8]"
                        />
                        <button className="text-[white] px-4 py-2 rounded-r-md bg-[#01A49E]">SUBSCRIBE</button>
                    </div>
                    <p className="text-xs text-[#4B5563] mt-2">
                        By subscribing, you accept the{" "}
                        <span onClick={() => goTo("/privacypolicy")} className=" cursor-pointer underline text-[black]">
                            Privacy Policy
                        </span>
                    </p>

                    {/* Contact Info */}
                    <div className="mt-4 space-y-1 text-sm">
                        {/* <p>
                            Hotline 24/7: <span className="text-[#01A49E] font-semibold">(+325) 3686 25 16</span>
                        </p> */}
                        <p>
                            Work Hours: <span className="text-[#4B5563]">Monday – Saturday: 9:00 AM – 5:00 PM</span>{" "}
                        </p>
                        <p>
                            Mail: <span className="text-[#4B5563]"> contact@alikstore.com</span>
                        </p>
                    </div>

                    {/* Social Icons */}
                    <div className="flex space-x-3 mt-4 text-lg">
                        <div className="bg-[#dfe2e8] p-2 rounded-full">
                            <FaTwitter />
                        </div>
                        <div className="bg-[#dfe2e8] p-2 rounded-full">
                            <FaFacebookF />
                        </div>
                        <div className="bg-[#dfe2e8] p-2 rounded-full">
                            <FaInstagram />
                        </div>
                        <div className="bg-[#dfe2e8] p-2 rounded-full">
                            <FaYoutube />
                        </div>
                        <div className="bg-[#dfe2e8] p-2 rounded-full">
                            <FaPinterestP />
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex-col md:grid grid-cols-3 hidden">
                <div>{""}</div>
                <div className="flex flex-row justify-center items-center gap-4">
                    {/* <img src={paypal} alt="paypal" className="h-5" /> */}
                    <img src={mastercard} alt="mastercard" className="h-7" />
                    <img src={visa} alt="visa" className="h-10" />
                </div>
                <div className="md:hidden">{""}</div>
                <div className="md:hidden">{""}</div>
                <div className="flex flex-col sm:flex-row items-center gap-3">
                    {/* <span className="text-sm font-medium">Download App</span> */}

                    <button className="flex items-center gap-1">
                        <img src={appstore} alt="App Store" className="h-7" />
                    </button>

                    <button className="flex items-center gap-1 ">
                        <img src={googleplay} alt="Google Play" className="h-7" />
                    </button>
                </div>
            </div>
            {/* mobile */}
            <div className="flex-col grid grid-cols-3 md:hidden">
                <div>{""}</div>
                <div className="flex flex-row justify-center items-center gap-4">
                    {/* <img src={paypal} alt="paypal" className="h-5" /> */}
                    <img src={mastercard} alt="mastercard" className="h-7" />
                    <img src={visa} alt="visa" className="h-10" />
                </div>
                <div className="md:hidden">{""}</div>
            </div>
            <div className="md:hidden">
                <div className="flex flex-row justify-center items-center gap-3">
                    <button className="flex items-center gap-1">
                        <img src={appstore} alt="App Store" className="h-7" />
                    </button>

                    <button className="flex items-center gap-1 ">
                        <img src={googleplay} alt="Google Play" className="h-7" />
                    </button>
                </div>
            </div>

            {/* Bottom bar */}
            <div className="border-t border-[#E5E7EB] mt-8 px-4 sm:px-8 md:px-16 py-4 flex flex-col md:flex-row justify-center items-center gap-2 text-sm">
                <p>
                    © 2025 <span className="font-bold ">Shersoft</span>. All Rights Reserved
                </p>
            </div>
        </div>
    );
}

export default Footer;
